export default "__VITE_ASSET__BRKaKADU__"